(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConfirmPasswordResetController', ConfirmPasswordResetController);

        ConfirmPasswordResetController.$inject = ['$modalInstance', 'email', 'authentication'];

    function ConfirmPasswordResetController($modalInstance, email, authentication) {
        var vm = this;

        vm.onAccept = onAccept;

        function onAccept() {
            $modalInstance.close();
        }
    }
})();